import * as React from 'react';
import {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {Button, TextField} from "@mui/material";
import RedeemVoucher from "../RedeemVoucher/RedeemVoucher";
import VouchersFindShowTable from "./VouchersFindShowTable";

/*
    Find vouchers
    @param {int} vet_id
 */
export default function VouchersFind({vet_id}) {

    const [loading,setLoading] = useState(true);
    const [data,setData] = useState([])
    const [dataTbl,setDataTbl] = useState([]);
    const [searchTerm,setSearchTerm] = useState('');
    const [currentRow,setCurrentRow] = useState([]);
    const [showModal,setShowModal] = useState(false);

    useEffect(() => {
        getData();
    },[loading])

    useEffect(() => {
        setDataTbl(data);
    },[data])

    function getData() {

        // setLoading(true);

        setTimeout(
            FunctionsData.fetchDataGet(
                FunctionsData.getApiUrl('/api/voucher/used/') + vet_id + "?search="+searchTerm,
                setData,
                true,
                setLoading
            ),
            3000
        );
    }

    if(dataTbl.length === 0) return (
        <div style={{minHeight:200}}>
            <div style={{display:'flex', flex:'1 0 100%'}}>
                <TextField sx={{flexGrow:1}}
                           placeholder={"Start typing to search for a voucher number ..."}
                           variant="outlined"
                           value={searchTerm}
                           onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button variant={"contained"} style={{flexGrow:0, marginLeft:10}} onClick={getData}>Search voucher</Button>
            </div>
            <h5>No vouchers assigned to other vets available at that time.</h5>

        </div>
    )

    if(loading === true) return (
        <div style={{padding:20}}>
            <h3>Loading ...</h3>
        </div>
    )
    return (
        <div style={{minHeight:200}}>
            <div style={{display:'flex', flex:'1 0 100%'}}>
                <TextField sx={{flexGrow:1}}
                           placeholder={"Start typing to search for a voucher number ..."}
                           variant="outlined"
                           value={searchTerm}
                           onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Button variant={"contained"} style={{flexGrow:0, marginLeft:10}} onClick={getData}>Search voucher</Button>
            </div>

            <VouchersFindShowTable dataTbl={dataTbl}  setCurrentRow={setCurrentRow} setShowModal={setShowModal} />

            <RedeemVoucher
                key={2}
                showModal={showModal}
                setShowModal={setShowModal}
                currentRow={currentRow}
                setReloadOriginal={setLoading}
            />
        </div>
    )


}
